export default "assets/images/bg-papier-71a5c86f.jpg";